export default "__VITE_ASSET__5b380d6c__"